import { spacing2x, spacing3x, spacing4x, spacing6x, borderRadiusSm, fontSizeSm, fontWeightMedium } from "@airhelp/design-tokens";
import { alertAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";
const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(alertAnatomy.keys);
const baseStyle = definePartsStyle((props) => {
    const { status } = props;
    const defaultBase = {
        container: {
            button: {
                background: "rgba(255,255,255,0)",
                top: "unset",
                right: spacing4x,
                width: spacing6x,
                height: spacing6x,
                borderRadius: borderRadiusSm,
                padding: 0,
                svg: {
                    boxSize: spacing3x,
                },
                _hover: {
                    background: "rgba(255,255,255,0.16)",
                },
                _active: {
                    background: "rgba(255,255,255,0.24)",
                },
            },
        },
        title: {
            fontSize: fontSizeSm,
            fontWeight: fontWeightMedium,
            paddingRight: spacing2x,
        },
        description: {
            fontSize: fontSizeSm,
        },
    };
    const successBase = status === "success" && {
        container: {
            ...defaultBase.container,
            background: "success.600",
            color: "greyscale.100",
        },
        icon: {
            color: "greyscale.100",
        },
        title: {
            ...defaultBase.title,
            color: "greyscale.100",
        },
        description: {
            ...defaultBase.description,
            color: "greyscale.100",
        },
    };
    const warningBase = status === "warning" && {
        container: {
            ...defaultBase.container,
            background: "warning.500",
            color: "greyscale.100",
        },
        icon: {
            color: "greyscale.100",
        },
        title: {
            ...defaultBase.title,
            color: "greyscale.100",
        },
        description: {
            ...defaultBase.description,
            color: "greyscale.100",
            fontSize: "sm",
        },
    };
    const errorBase = status === "error" && {
        container: {
            ...defaultBase.container,
            background: "secondary.500",
            color: "greyscale.100",
        },
        icon: {
            color: "greyscale.100",
        },
        title: {
            ...defaultBase.title,
            color: "greyscale.100",
        },
        description: {
            ...defaultBase.description,
            color: "greyscale.100",
            fontSize: "sm",
        },
    };
    const infoBase = status === "info" && {
        container: {
            ...defaultBase.container,
            background: "primary.600",
            color: "greyscale.100",
        },
        icon: {
            color: "greyscale.100",
        },
        title: {
            ...defaultBase.title,
            color: "greyscale.100",
        },
        description: {
            ...defaultBase.description,
            color: "greyscale.100",
            fontSize: "sm",
        },
    };
    const loadingBase = status === "loading" && {
        container: {
            ...defaultBase.container,
            background: "primary.600",
            color: "greyscale.100",
        },
        icon: {
            color: "greyscale.100",
        },
        title: {
            ...defaultBase.title,
            color: "greyscale.100",
        },
        description: {
            ...defaultBase.description,
            color: "greyscale.100",
            fontSize: "sm",
        },
    };
    return {
        ...successBase,
        ...warningBase,
        ...errorBase,
        ...infoBase,
        ...loadingBase,
    };
});
const Alert = defineMultiStyleConfig({ baseStyle });
export default Alert;
